<ng-container>
  <app-common-bank-view></app-common-bank-view>
</ng-container>
